import { render, staticRenderFns } from "./PasswordStrengthLabel.vue?vue&type=template&id=2b6c15f0&scoped=true&"
import script from "./PasswordStrengthLabel.vue?vue&type=script&lang=ts&"
export * from "./PasswordStrengthLabel.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordStrengthLabel.vue?vue&type=style&index=0&id=2b6c15f0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6c15f0",
  null
  
)

export default component.exports